export default __webpack_public_path__ + "static/qawhat-2-456839d71f59da05050852e0cad5595b.png";